module.exports = __webpack_public_path__ + "img/agpz-car-selected.7fb809e5.svg";